"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var DialogActions_1 = __importDefault(require("../DialogActions"));
var DialogContent_1 = __importDefault(require("../DialogContent"));
var useMediaQuery_1 = __importDefault(require("../hooks/useMediaQuery"));
var ModalNav_1 = __importDefault(require("./ModalNav"));
var styles_1 = require("./styles");
var ModalContent = function (_a) {
    var actions = _a.actions, backText = _a.backText, backDataTestId = _a.backDataTestId, backButtonProps = _a.backButtonProps, children = _a.children, id = _a.id, onBack = _a.onBack, onClose = _a.onClose, title = _a.title, hideTitle = _a.hideTitle, titleTypographyProps = _a.titleTypographyProps, fullScreen = _a.fullScreen, disableCloseButton = _a.disableCloseButton, disableBackText = _a.disableBackText, backTextAutoFocus = _a.backTextAutoFocus;
    var _b = __read(react_1.default.useState(null), 2), content = _b[0], setContent = _b[1];
    var _c = __read(react_1.default.useState(false), 2), upperShadow = _c[0], setUpperShadow = _c[1];
    var _d = __read(react_1.default.useState(false), 2), lowerShadow = _d[0], setLowerShadow = _d[1];
    var isMobile = (0, useMediaQuery_1.default)(_1.mobileMediaQuery);
    var hasActions = actions !== undefined && react_1.default.Children.count(actions) > 0;
    var hasNav = onBack || title || onClose;
    react_1.default.useEffect(function () {
        if (content) {
            var setScrollVars_1 = function () {
                if (content.scrollTop < 5) {
                    setUpperShadow(false);
                }
                else {
                    setUpperShadow(true);
                }
                if (content.scrollTop + content.offsetHeight >
                    content.scrollHeight - 5) {
                    setLowerShadow(false);
                }
                else {
                    setLowerShadow(true);
                }
            };
            var resizeObserver_1 = 'ResizeObserver' in window ? new ResizeObserver(setScrollVars_1) : null;
            setScrollVars_1();
            content.addEventListener('scroll', function () { return setScrollVars_1(); });
            if (resizeObserver_1)
                resizeObserver_1.observe(content);
            return function () {
                content.removeEventListener('scroll', setScrollVars_1);
                if (resizeObserver_1)
                    resizeObserver_1.unobserve(content);
            };
        }
    }, [content, setUpperShadow, setLowerShadow]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        hasNav && (react_1.default.createElement(ModalNav_1.default, { backText: backText, backButtonProps: backButtonProps, backDataTestId: backDataTestId, id: id, onBack: onBack, onClose: onClose, title: title, hideTitle: hideTitle, titleTypographyProps: titleTypographyProps, fullScreen: fullScreen, disableCloseButton: disableCloseButton, disableBackText: disableBackText, upperShadow: upperShadow, backTextAutoFocus: backTextAutoFocus, isMobile: isMobile })),
        fullScreen ? (react_1.default.createElement(DialogContent_1.default, { ref: setContent, "data-testid": "DialogContent:FullScreen" },
            react_1.default.createElement(styles_1.FullScreenContainer, null,
                children,
                react_1.default.createElement(DialogActions_1.default, { sx: { marginTop: '48px' } }, actions)))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.StyledDialogContent, { ref: setContent, "data-testid": "DialogContent:Standard", hasNoActionsAndNav: !hasActions && !hasNav }, children),
            hasActions && (react_1.default.createElement(styles_1.CustomDialogActions, { className: lowerShadow ? 'shadow' : undefined, isMobile: isMobile }, actions))))));
};
exports.default = ModalContent;
//# sourceMappingURL=ModalContent.js.map